export default __webpack_public_path__ + "static/media/down-transition-white.14d3cd95.svg";